export const AXIS_COLOR_SCHEMES = [
  {
    id: 'slate',
    label: 'Slate Contrast',
    description: 'Balanced neutral tones that match the default DWLF palette.',
    colors: {
      dark: '#94a3b8',
      light: '#475569',
    },
  },
  {
    id: 'sky',
    label: 'Sky Focus',
    description: 'Cool blue highlights for crisp crosshairs on dark charts.',
    colors: {
      dark: '#bae6fd',
      light: '#1e3a8a',
    },
  },
  {
    id: 'sunset',
    label: 'Sunset Glow',
    description: 'Warm golden guides that stand out against dark backgrounds.',
    colors: {
      dark: '#facc15',
      light: '#92400e',
    },
  },
];

export const DEFAULT_AXIS_COLOR_SCHEME = AXIS_COLOR_SCHEMES[0].id;

const AXIS_COLOR_SCHEME_MAP = AXIS_COLOR_SCHEMES.reduce((acc, scheme) => {
  acc.set(scheme.id, scheme);
  return acc;
}, new Map());

export const getAxisColorScheme = (schemeId) => {
  if (schemeId && AXIS_COLOR_SCHEME_MAP.has(schemeId)) {
    return AXIS_COLOR_SCHEME_MAP.get(schemeId);
  }
  return AXIS_COLOR_SCHEME_MAP.get(DEFAULT_AXIS_COLOR_SCHEME);
};

export const getAxisColorsForScheme = (schemeId) => getAxisColorScheme(schemeId).colors;

export const CROSSHAIR_SNAP_MODES = [
  {
    id: 'series',
    label: 'Snap to data',
    description: 'Align the horizontal guide with the closest candle or indicator value.',
  },
  {
    id: 'pointer',
    label: 'Follow pointer',
    description: 'Let the horizontal guide track your cursor position exactly.',
  },
];

const CROSSHAIR_SNAP_MODE_SET = new Set(CROSSHAIR_SNAP_MODES.map((mode) => mode.id));

export const DEFAULT_CROSSHAIR_SNAP_MODE = 'series';

export const normalizeCrosshairSnapMode = (value) => (
  CROSSHAIR_SNAP_MODE_SET.has(value) ? value : DEFAULT_CROSSHAIR_SNAP_MODE
);

export const DEFAULT_SHOW_CROSSHAIR_PRICE_LABEL = true;

export const normalizeCrosshairPriceLabelPreference = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const lower = value.trim().toLowerCase();
    if (lower === 'true') {
      return true;
    }
    if (lower === 'false') {
      return false;
    }
  }
  return DEFAULT_SHOW_CROSSHAIR_PRICE_LABEL;
};

export const DEFAULT_SHOW_ADAPTIVE_GRID = true;

export const normalizeAdaptiveGridPreference = (value) => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const lower = value.trim().toLowerCase();
    if (lower === 'true') {
      return true;
    }
    if (lower === 'false') {
      return false;
    }
  }
  return DEFAULT_SHOW_ADAPTIVE_GRID;
};

